import type { TPrepPriceRanges } from '@/_models';

import type { IPriceRange } from './types';

export const getPerCoursePriceByPriceRanges = (
  totalSelectedAllCourses: number,
  prepPriceRanges: TPrepPriceRanges = []
): number => {
  if (totalSelectedAllCourses === 0) return 0;

  let maxRangeIndex = 0;
  const priceRange = prepPriceRanges.find((r, i) => {
    if (totalSelectedAllCourses >= r.min && totalSelectedAllCourses <= r.max) {
      if (i > 0) {
        if (r.max > prepPriceRanges[i - 1].max) {
          maxRangeIndex = i;
        }
      }

      return true;
    }
    return false;
  });

  if (!priceRange && totalSelectedAllCourses > prepPriceRanges[maxRangeIndex]?.max) {
    return parseFloat(`${prepPriceRanges[maxRangeIndex]?.price ?? 0}`);
  }

  return parseFloat(`${priceRange ? priceRange.price : 0}`);
};

export function getInvestment({
  modelType,
  totalSelectedPrepCourses,
  totalSelectedOdtCourses,
  totalSelectedFundamentalCourses,
  totalSelectedCourses,
  prepPriceRanges,
  odtPriceRanges,
  fundamentalPriceRanges,
}: Omit<IPriceRange, 'account_charge' | 'isReviseMode' | 'isClimb'>) {
  // per course prices
  const perPrepCoursePrice = getPerCoursePriceByPriceRanges(totalSelectedCourses, prepPriceRanges);
  const perOdtCoursePrice = getPerCoursePriceByPriceRanges(totalSelectedCourses, odtPriceRanges);

  const perFundamentalCoursePrice = getPerCoursePriceByPriceRanges(
    totalSelectedCourses,
    modelType === 'UNIFIED_PRICING_1' || modelType === 'UNIFIED_PRICING_2' ? prepPriceRanges : fundamentalPriceRanges
  );

  const totalPrepCourseInvestment = perPrepCoursePrice * totalSelectedPrepCourses;
  const totalOdtCourseInvestment = perOdtCoursePrice * totalSelectedOdtCourses;
  const totalFundamentalCourseInvestment = perFundamentalCoursePrice * totalSelectedFundamentalCourses;

  // total prices without down payment and pre buy bridge plan
  const totalInvestment = totalPrepCourseInvestment + totalOdtCourseInvestment + totalFundamentalCourseInvestment;

  return {
    totalInvestment,
    totalPrepCourseInvestment,
    totalOdtCourseInvestment,
    totalFundamentalCourseInvestment,
    perPrepCoursePrice,
    perOdtCoursePrice,
    perFundamentalCoursePrice,
  };
}
